import { removeMaskOfTelephone } from "./telephone.functions";

export function completeNameRule( input ) {
    if(input == ' ' || input == null || input == undefined )  return false

    let index = 0

    if( input.includes(' ') ) {
        index = input.indexOf(' ', 1)

        if( input[index + 1] == ' ' ) {
            return false
            
        } else {
            completeNameRule( input.substring(index + 1))
        }
    }

    if( index < input.length - 1 && index > 0 ) return true
    else return false
}

export function telephoneRule ( input ) {
    if(input == ' ' || input == null || input == undefined )  return false

    let telephoneWithOutMask = removeMaskOfTelephone(input)
    if( telephoneWithOutMask.length == 10 || telephoneWithOutMask.length == 11 ) {
        return true

    }else return false
}

export function passwordRule( input ) {
    if( input ) {
        if( input.length < 8 ) {
            return false
    
        }else return true 

    } else return false 
}

export function cardNumberRule( input ) {
    if( input && input.length < 19 ) return false

    if( /[0-9]/.test(input) ) return true

    return false
}

export function cardCvvRule( input ) {
    if( /^[0-9]{3,4}$/.test(input) ) return true 

    return false
}

export function cpfRule( input ) {
    if( /(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/.test(input) ) return true 

    return false
}

export function cardExpiresRule( input ) {
    if( /^\d{2}\/\d{2}$/.test(input) ) return true

    return false
}

export function passwordConfirmationRule( input, inputConfirmation ) {
    if( input && inputConfirmation ) {
        const inputTrim = input.trim()
        const inputConfirmationTrim = inputConfirmation.trim()

        if( inputTrim == inputConfirmationTrim ) return true 

    } else return false 
}